import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SchemaFormModule, WidgetRegistry } from './angular2-schema-form-shim';
import { ContenteditableDirective } from './contenteditable.directive';

import { ArrayWidget } from './widgets/array.widget';
import { CheckboxWidget } from './widgets/checkbox.widget';
import { FileWidget } from './widgets/file.widget';
import { IntegerWidget } from './widgets/integer.widget';
import { ObjectWidget } from './widgets/object.widget';
import { RadioWidget } from './widgets/radio.widget';
import { RangeWidget } from './widgets/range.widget';
import { SelectWidget } from './widgets/select.widget';
import { StringWidget } from './widgets/string.widget';
import { TextAreaWidget } from './widgets/textarea.widget';
import { ButtonWidget } from './widgets/button.widget';
import { ButtonGroupWidget } from './widgets/buttongroup.widget';
import { MessageWidget } from './widgets/message.widget';
import { POPQWidget } from './widgets/popq.widget';
import { TagListWidget } from './widgets/taglist.widget';
import { DividerWidget } from './widgets/divider.widget';

import { DurationDaysWidget } from "./widgets/custom/durationdays.widget";

import { SPWidgetRegistry } from './widgets/registry';
import { WidgetValidationError } from './error.component';
import { WidgetTooltip } from './tooltip.component';

import { DefaultValuePipe } from "./pipes/default-value.pipe";

import { FormElementComponent } from './formelement.component';
import { FormElementComponentToast } from './formelement.toast.component';
import { FormComponent } from './form.component';

import { AppComponent } from './app.component';

@NgModule( {
  declarations: [
    AppComponent,
    FormElementComponent,
    FormElementComponentToast,
    FormComponent,
    ArrayWidget,
    CheckboxWidget,
    FileWidget,
    IntegerWidget,
    ObjectWidget,
    RadioWidget,
    RangeWidget,
    SelectWidget,
    StringWidget,
    TextAreaWidget,
    ButtonWidget,
    ButtonGroupWidget,
    MessageWidget,
    POPQWidget,
    TagListWidget,
    DividerWidget,
    DurationDaysWidget,
    WidgetValidationError,
    WidgetTooltip,
    ContenteditableDirective,
    DefaultValuePipe,
  ],
  entryComponents: [
    FormElementComponent,
    FormElementComponentToast,
    FormComponent,
    ArrayWidget,
    CheckboxWidget,
    FileWidget,
    IntegerWidget,
    ObjectWidget,
    RadioWidget,
    RangeWidget,
    SelectWidget,
    StringWidget,
    TextAreaWidget,
    ButtonWidget,
    ButtonGroupWidget,
    MessageWidget,
    POPQWidget,
    TagListWidget,
    DividerWidget,
    DurationDaysWidget,
    WidgetValidationError,
    WidgetTooltip,
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    SchemaFormModule,
    BrowserModule,
  ],
  providers: [
    {
      provide: WidgetRegistry,
      useClass: SPWidgetRegistry,
    }
  ],
  bootstrap: [ AppComponent ],
} )
export class AppModule { }



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/app.module.ts